import {Routes, UrlSegment} from '@angular/router';
import {Error404Component} from "@features/error/components/404.component";
import {MOBILE_CHILDREN_ROUTES} from '@layouts/mobile/mobile.routes.const';
import {publicLayoutMatcher} from './web.routes';
import {LegacyAppConversationRedirectGuard} from '@core/guards';

// Xoá mobileLayoutMatcher vì tất cả đều dùng MobileModule

export const AppRoutes: Routes = [
  {
    path: 'app/conversation',
    canActivate: [LegacyAppConversationRedirectGuard],
    component: Error404Component,
  },
  {
    path: 'auth',
    loadChildren: () => import('@features/auth/auth.module').then(m => m.AuthModule),
  },
  // Các trang công khai sử dụng Layout tối giản (Checkout, Cart)
  {
    matcher: publicLayoutMatcher,
    loadChildren: () => import('@layouts/layout-public/layout-public.module').then(m => m.LayoutPublicModule),
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('@layouts/mobile/mobile.module').then(m => m.MobileModule),
      },
      {
        path: 'error',
        loadChildren: () => import('@features/error/error.module').then((m) => m.ErrorModule)
      },
      {path: '**', component: Error404Component},
    ],
  }
];
